import React from "react";
import { Button, Typography, Modal, Fade, Box, IconButton, Menu, MenuItem } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { ReactComponent as CloseIcon } from "../../../assets/icons/icon_close.svg";
import { ChartType } from "ag-grid-community";
import { ReactComponent as OrderIcon } from "../../../assets/icons/icon-chart-order.svg";
import {handleLanguageChange } from "../../../utils/multiLangDashboardV2Data"
import { isMobileDevice } from "../../../utils/Reusables";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #fff',
        boxShadow: '0px 0px 4px #0000001A',
        padding: '0rem',
        minWidth: '700px',
        maxWidth: '700px',
        borderRadius: '4px',
        // textAlign: 'center',
        boxShadow: '0px 0px 4px #0000001A',
        position: 'relative',
    },
    modalTitle: {
        fontSize: '18px',
    }
}));

export default function ChartEnlargePopupView(props) {
    const classes = useStyles();
    let { openPopup, ChartComponent, handleClose, reportName, handleOrderByDrop, chartObj, handleOrderEleClick, 
        selectedOrderByReport, getItemDisplayName, handleOrderBy, currentOrderElement } = props;
    const [orientation, setOrientation] = React.useState('portrait');
    let [chartType, setChartType] = React.useState(null);
    let [orderByAnchorEl, setOrderByAnchorEl] = React.useState(null);
    let [currentOrderAnchorEl, setCurrentOrderAnchorEl] = React.useState(null);

    React.useEffect(() => {
        if(props?.chartObj?.chartType != null){
            setChartType(props?.chartObj?.chartType);
        }
        orientationSetup();
        window.addEventListener('resize', orientationSetup);
    }, []);

    const orientationSetup = () => {
        let mode = "portrait";
        if(window.innerWidth < 1024 && isMobileDevice()){
            mode = (window.screen.availWidth < window.screen.availHeight) ? "landscape" : "portrait";
        }
        setOrientation(mode);
    }

    const handleOrderByClose = () => {
        setOrderByAnchorEl(null);
      }

    const handlePopup = (report, index, event) => {
        setOrderByAnchorEl(event.target);
        handleOrderByDrop(report, index, event);
      }

    const handleOrderByEleClose = () => {
        setCurrentOrderAnchorEl(null);
      }

    const handlePopOrderby = (order) => {
        handleOrderByEleClose();
        handleOrderBy(order);
    }

    const handlePopupOrderEleClick = (e, order) => {
        setCurrentOrderAnchorEl(e.target);
        handleOrderEleClick(order)
    }

    return (
        <>

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={openPopup}
            onClose={() => {return false}}
            closeAfterTransition
        >
            <Fade in={openPopup} id="enlarge-modal">
                <Box className={classes.modalPaper +  " modal-box modal-full modal-report 11 " + orientation} data-width={window.innerWidth}
                    data-height={window.innerHeight}>
                    <Box className="modal-header" >
                        <Typography variant="subtitle1" className={classes.modalTitle + " modal-header-title folder-modal-title"} >{handleLanguageChange(reportName)}</Typography>
                        <CloseIcon onClick={handleClose} className="enlarge-close" />
                        {/* {
                        (chartType == 'bar') ?
                        <IconButton className="form-icon-btn order-icon-modal" onClick={(e) => handlePopup(chartObj, undefined, e)} >
                          <OrderIcon />
                        </IconButton>
                        : null

                        } */}
                    </Box>
                    <Box className="modal-content-enlarge-view">
                        <div className="published-modal-body">
                            {ChartComponent}
                        </div>
                    </Box>
                </Box>
            </Fade>
        </Modal>

        <Menu
        id="simple-menu"
        anchorEl={orderByAnchorEl}
        keepMounted
        open={Boolean(orderByAnchorEl)}
        onClose={handleOrderByClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {
          selectedOrderByReport && selectedOrderByReport?.report?.orderBy && Object.keys(selectedOrderByReport?.report?.orderBy).map((order, index) => (
            <MenuItem key={index} onClick={e => handlePopupOrderEleClick(e, order)} className="text-plain font-weight-500">{getItemDisplayName(order, selectedOrderByReport?.report)}</MenuItem>

          ))
        }
      </Menu>

      <Menu
          id="simple-menu"
          anchorEl={currentOrderAnchorEl}
          keepMounted
          open={Boolean(currentOrderAnchorEl)}
          onClose={handleOrderByEleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={e => handlePopOrderby('asc')} className={selectedOrderByReport?.report?.orderBy[currentOrderElement] === 'asc' && 'visualize_list_text'}>Asc</MenuItem>
          <MenuItem onClick={e => handlePopOrderby('desc')} className={selectedOrderByReport?.report?.orderBy[currentOrderElement] === 'desc' && 'visualize_list_text'}>Desc</MenuItem>

        </Menu>

      </>
    );
}
